import { valueCurrencyShortcut } from 'helpers/priceHelpers';
import { useCustomTranslation } from 'helpers/translationHelper';
import type { TravelCost } from 'pages/orders/models';
import React from 'react';

interface OwnProps {
  travel: TravelCost[];
  title?: string;
  hasFlatRateTravelFee?: boolean;
  travelFee?: number | null;
  pricePerKm?: number;
  currencyId: string;
  showPrice: boolean;
}

const TravelBlock = (props: OwnProps) => {
  const { travel, title, hasFlatRateTravelFee, travelFee, pricePerKm, currencyId, showPrice } =
    props;
  const { t } = useCustomTranslation();

  const travelSummary = travel.reduce((acc, cur) => {
    return acc + cur.distance * (pricePerKm || 0);
  }, 0);

  const summaryText = hasFlatRateTravelFee
    ? `${valueCurrencyShortcut(travelFee || 0, currencyId, t)}`
    : valueCurrencyShortcut(travelSummary, currencyId, t);

  return (
    <div className="TravelBlock">
      <div className="SectionTitle">{title}</div>
      {travel.length > 0 || hasFlatRateTravelFee ? (
        <table>
          <thead>
            <tr>
              <th>{t('customData.travel.distance')}</th>
              <th>{t('customData.travel.description')}</th>
              {showPrice && <th className="priceCol">{t('customData.travel.price')}</th>}
            </tr>
          </thead>
          <tbody>
            {travel.map((travel) => (
              <tr key={travel.id}>
                <td>{travel.distance}</td>
                <td>{travel.description}</td>
                {showPrice && (
                  <td className="priceCol">
                    {!hasFlatRateTravelFee &&
                      valueCurrencyShortcut(travel.distance * (pricePerKm || 0), currencyId, t)}
                  </td>
                )}
              </tr>
            ))}
            {hasFlatRateTravelFee && (
              <tr>
                <td />
                <td>{t('customData.travel.hasFlatTravelFeeLabel')}</td>
                {showPrice && (
                  <td className="priceCol">
                    {valueCurrencyShortcut(travelFee || 0, currencyId, t)}
                  </td>
                )}
              </tr>
            )}
            {showPrice && (
              <tr>
                <td colSpan={2} />
                <td className="priceCol">{summaryText}</td>
              </tr>
            )}
          </tbody>
        </table>
      ) : (
        <div className="EmptyPlaceholder">{t('customData.travel.empty')}</div>
      )}
    </div>
  );
};

export default TravelBlock;
